import __request__ from "routing/request";
export function fieldTypeSummaries(JSONbody, sort = "index_set_id", page = 1, per_page = 50, order = "asc") {
  return __request__("POST", "/system/indices/index_sets/types", JSONbody, { "page": page, "per_page": per_page, "sort": sort, "order": order }, {
    "Accept": ["application/json"]
  });
}
export function indexSetsWithFieldTypeChangeSupport(Streamids) {
  return __request__("POST", "/system/indices/index_sets/types/index_sets_with_field_type_change_support", Streamids, {}, {
    "Accept": ["application/json"]
  });
}
export function indexSetFieldTypesList(sort = "field_name", index_set_id, query, filters, page = 1, per_page = 50, order = "asc") {
  return __request__("GET", `/system/indices/index_sets/types/${index_set_id}`, null, { "query": query, "filters": filters, "page": page, "per_page": per_page, "sort": sort, "order": order }, {
    "Accept": ["application/json"]
  });
}
export function indexSetFieldTypesListByindex_set_idAndfieldNameQueryAndfiltersAndsortAndorder(sort = "field_name", index_set_id, fieldNameQuery, filters, order = "asc") {
  return __request__("GET", `/system/indices/index_sets/types/${index_set_id}/all`, null, { "fieldNameQuery": fieldNameQuery, "filters": filters, "sort": sort, "order": order }, {
    "Accept": ["application/json"]
  });
}
